/**
 * formatContextText
 * 
 * Normalizes context strings uniformly across the Issues system:
 * - Replaces "Programming Labs" with "Labs"
 * - Removes redundant "(Quiz)" suffixes from activity titles
 * - Preserves other categories (e.g. "Multimedia Book > ...")
 *
 * Examples:
 *   "Programming Labs > Lab 1 > Quiz 1 (Quiz)" -> "Labs > Lab 1 > Quiz 1"
 *   "Programming Labs > Lab 1 > Activity 1"    -> "Labs > Lab 1 > Activity 1"
 *   "Labs > Lab 1 > Quiz 1 (Quiz)"             -> "Labs > Lab 1 > Quiz 1"
 *   "Programming Labs"                         -> "Labs"
 */
export const formatContextText = (text) => {
  if (!text || typeof text !== 'string') return '';
  return text
    .replace(/^Programming Labs?\s*>\s*/i, 'Labs > ')
    .replace(/^Programming Labs?\s*\/\s*/i, 'Labs > ')
    .replace(/^Programming Labs?$/i, 'Labs')
    .replace(/\s*\(Quiz\)/gi, '')
    .trim();
};

export default formatContextText;

